/** @type {Styles} */
export const styles = {
  divider: {
    marginY: 1,
  },
  activeRequestTitle: { flex: 1, display: 'flex', alignItems: 'center' },
  activeRequestWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  closeButton: {
    flex: 0,
    display: 'flex',
    alignItems: 'center',
  },
  menuBox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: 2,
  },
  activeRequestsBox: {
    width: '100%',
  },
  activeRequestsTypography: {
    color: 'gray.64',
    paddingX: 2,
    paddingBottom: 1,
    flex: 1,
  },
  activeRequestItem: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginY: 0.5,
    borderRadius: 1,
    paddingLeft: 2,
  },
  activeRequestItemLabel: {
    color: 'gray.80',

    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
  activeRequestItemStatus: {
    color: 'primary.main',
  },
  requestHistoryItemLabel: {
    color: 'gray.80',

    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
  requestHistoryItem: {
    flex: 1,

    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  requestHistoryBoxWhite: {
    height: '100%',
    backgroundColor: 'white',
  },
  requestHistoryBox: {
    height: '100%',
    flex: 1,
    backgroundColor: 'gray.3',
  },
  requestHistoryHeader: {
    display: 'flex',

    alignItems: 'center',
    paddingLeft: 2,
    paddingTop: 2,
  },
  requestHistoryTitle: {
    color: 'gray.64',
    flex: 1,
  },
  clearHistoryTypography: {
    cursor: 'pointer',
    color: 'primary.main',
  },
  noHistoryTypography: {
    px: 2,
    py: 1,
  },
  upRightIconStyles: {
    color: 'primary.main',
  },
}
